import React, { useEffect, useRef, useState } from 'react';
import { MoreVertical } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Standalone three-dot card menu matching the SpaceBring design system.
 */
export default function CardMenu({ items = [], className }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const visibleItems = items.filter(Boolean);

  useEffect(() => {
    if (!open) return undefined;
    const handleClick = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  if (visibleItems.length === 0) return null;

  return (
    <div className={cn('relative', className)} ref={ref}>
      <button
        type="button"
        onClick={e => {
          e.stopPropagation();
          setOpen(o => !o);
        }}
        className="p-1 rounded-md text-mute hover:text-ink hover:bg-paper transition-colors"
        aria-label="Card actions">
        <MoreVertical className="w-4 h-4" />
      </button>
      {open && (
        <div className="absolute right-0 top-7 z-20 w-44 py-1 rounded-[12px] bg-white border border-shell-border shadow-soft overflow-hidden">
          {visibleItems.map(({ label, icon: Icon, onClick, danger }) => (
            <button
              key={label}
              type="button"
              onClick={e => {
                e.stopPropagation();
                setOpen(false);
                onClick?.();
              }}
              className={cn(
                'w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left transition-colors',
                danger ? 'text-[#EF4444] hover:bg-[#EF4444]/10' : 'text-mute hover:bg-paper hover:text-ink',
              )}>
              {Icon && <Icon className="w-3.5 h-3.5 flex-shrink-0" />}
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
